import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import ElipsesSingleLine from "core/ElipsesSingleLine.js";

// styles
import colors, { focusStyles } from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";

const ContentStyled = styled.div`
    flex: 1;
    min-width: 0; /* Important for text-overflow to work */
    text-align: left;
    display: flex;
    align-items: center;
`;

/**
 * Handling Elipses with Flexbox
 * Centers Vertically inside ContentStyled { display: flex; }
 * When display: flex is used on an ancestor, the child
 * does not respect text-overflow: hidden, and therefore ellipsis
 * because flex items can shrink unpredictably.
 */
const InnerWrapper = styled.div`
    min-width: 0; /* Important for text-overflow to work on elipses element  */
`;

const HeaderAnchorStyled = styled.a`
    display: ${({ $isLong }) => ($isLong ? "block" : "inline-block")};
    font-size: ${convertPxToRem(18)};
    color: ${({ $color }) => $color};
    margin-bottom: ${convertPxToRem(8)};

    text-decoration: none;
    border-bottom: solid 1px transparent;

    &:hover {
        border-bottom-color: ${({ $isDarkMode }) =>
            $isDarkMode ? colors.primary.diamond : colors.secondary.orca};
    }

    ${focusStyles}

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        font-size: ${convertPxToRem(16)};
    }
`;

const MembershipStyled = styled.div`
    font-size: ${convertPxToRem(12)};
    color: ${({ $color }) => $color};
    font-style: italic;
`;

const getLightDarkProps = (isMobile, isDarkMode) => {
    let headerTextColor = colors.secondary.orca;
    let membershipTextColor = colors.secondary.basalt;

    if (!isMobile && isDarkMode) {
        headerTextColor = colors.primary.diamond;
        membershipTextColor = colors.secondary.dolphin;
    }

    return { headerTextColor, membershipTextColor };
};

// data
import { USER_SETTINGS } from "data/links.js";

// component
export const Content = () => {
    const {
        isDarkMode,
        currentUser,
        viewport: { isMobile }
    } = useSiteHeader();
    if (!currentUser) return null;

    const { username, membership, displayName } = currentUser;
    const title = membership?.title || "Free Member";

    const { headerTextColor, membershipTextColor } = getLightDarkProps(
        isMobile,
        isDarkMode
    );

    const isLong = displayName.length > 18;

    return (
        <ContentStyled>
            <InnerWrapper>
                <HeaderAnchorStyled
                    $isDarkMode={isDarkMode}
                    $color={headerTextColor}
                    $isLong={isLong}
                    href={USER_SETTINGS.replace(":username", username)}
                >
                    {isLong ? (
                        <ElipsesSingleLine string={displayName} />
                    ) : (
                        displayName
                    )}
                </HeaderAnchorStyled>
                <MembershipStyled $color={membershipTextColor}>
                    {title}
                </MembershipStyled>
            </InnerWrapper>
        </ContentStyled>
    );
};

export default Content;
